module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/159-cambodia-13eba8d4145e2ac6a794070c8ad15b02.svg";